module.exports = __webpack_public_path__ + "img/salernitana.63633e5b.png";